import React from 'react';
import "../styles/Modal.scss"
import {ModalProps} from "../types";
import {useModal} from "../Contexts/Modal";


const Modal: React.FC<ModalProps> = ({children}) => {
    const { closeModal } = useModal();

    return (
        <div id={"overlay"} onClick={closeModal}>
            <div className={"modal"} onClick={(e) => e.stopPropagation()}>
                <button className={"closeButton circular"} onClick={closeModal}>✖</button>
                {children}
            </div>
        </div>
    );
};


export default Modal;
